import { render, staticRenderFns } from "./Extras-svgs.vue?vue&type=template&id=63cbc5be"
import script from "./Extras-svgs.vue?vue&type=script&lang=js"
export * from "./Extras-svgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports